import { Api, Auth } from '~/services'


export function getMainSearchContent( searchTerm ) {
	return ( dispatch, getStore ) => {
		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_MAIN_SEARCH'
				})

				Api.get( '/wp/search/' + encodeURI( searchTerm ), {
					secure_token: Auth.getToken()
				}, ( data, error ) => { 
					dispatch({
						type: 'RECEIVE_MAIN_SEARCH',
						articles: data && 'articles' in data ? data.articles : [],
						camps: data && 'camps' in data ? data.camps : [],
						interests: data && 'interests' in data ? data.interests : [],
						questions: data && 'questions' in data ? data.questions : [],
						statements: data && 'statements' in data ? data.statements : [],
						workshops: data && 'workshops' in data ? data.workshops : [],
					})
				})

			}
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/actions/search.js